//@ts-nocheck
import React from "react";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import QuestionCard from "./layout/QuestionCard.web";
import OptionList from "./layout/OptionList.web";
import StepFooter from "./layout/StepFooter.web";
import FirmQuestions from "./layout/FirmQuestions.web";

class TaxSavingStepStep extends React.Component {
  async componentDidMount() {
    const stepNo = this.props.taxPayerType === "individual" ? "7.2" : "7.1";
    this.props.getQuestionAndOptionsByStepNo(stepNo);
  }
  render() {
    const selection = this.props.taxSavingSelection || [];
    return (
      <>
        <QuestionCard
          title="Your goals"
          hint={
            this.props.taxPayerType === "individual"
              ? "If you could minimize your taxes, what would you do with the savings?"
              : "Select any elements you'd like to include in your package"
          }
        >
          <OptionList
            options={this.props?.stepContent?.options?.data}
            selected={selection}
            multiple
            onSelect={this.props.setTaxSavingSelection}
          />
        </QuestionCard>
        <FirmQuestions
          screen="tax_savings"
          taxPayerType={this.props.taxPayerType}
          questions={this.props.firmQuestions}
          answers={this.props.firmAnswers}
          onChange={this.props.setFirmAnswer}
        />
        <StepFooter
          onBack={this.props.handleBack}
          onNext={this.props.handleNext}
          nextDisabled={selection.length === 0}
        />
      </>
    );
  }
}
const TaxSavingStepStepWithRouter = withRouter(TaxSavingStepStep);
const TaxSavingStepStepAlertBox = withAlertBox(TaxSavingStepStepWithRouter);
const TaxSavingStepStepLoader = withLoader(TaxSavingStepStepAlertBox);
const TaxSavingStepStepToast = withToast(TaxSavingStepStepLoader);
const TaxSavingStepStepWithDialog = withDialog(TaxSavingStepStepToast);

export default withConfirmBox(TaxSavingStepStepWithDialog);
